<section class="common-back-btn">
    <div class="common-back-btn__back-eclaim-top" (click)="showEndClaimConfirmation()">
        <span class="common-back-btn__back-icon">
            <cds-icon [icon]="downloadIcon" aria-hidden="true"></cds-icon>
        </span>
        <span class="common-back-btn__back-message">
            {{'給付金らくらく請求トップに戻る' }}
        </span>
    </div>
</section>